// removed by extract-text-webpack-plugin
module.exports = {"content":"_1pOo-h3coViVPcsPpYX6r5","saveButton":"_3h1VTqQnSDfvrHuLes7Em5","cancelButton":"_1Q_EIv7Ck-AvFGgC5ri8w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/EditHoldingsForm.css
// module id = 779
// module chunks = 0